import { render, staticRenderFns } from "./CookiesConsent.vue?vue&type=template&id=3c5314ea&scoped=true"
import script from "./CookiesConsent.vue?vue&type=script&lang=js"
export * from "./CookiesConsent.vue?vue&type=script&lang=js"
import style0 from "./CookiesConsent.vue?vue&type=style&index=0&id=3c5314ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5314ea",
  null
  
)

export default component.exports